import React, { useEffect, useState, useMemo, useRef } from 'react'

import Label from './label'
import { useAdData } from '../context'
import { useAdStat } from 'Components/ad'
import { AdData } from './interface'
import applyHttpsImage from 'lib/apply-https-img'
// 视频下方的通栏广告

const TonglanAD2: React.FC<{}> = () => {
  const adData = useAdData()
  if (!adData) {
    return null
  }
  const targetAD = adData.video_down_banner_ad
  if (!targetAD || Object.keys(targetAD).length === 0) {
    return null
  }
  return <AdItem data={targetAD} />
}
function AdItem({ data }: { data: AdData['video_down_banner_ad'] }) {
  const { ref, handleClick } = useAdStat(
    {
      send: 'ad_send_home_page_middle_banner',
      show: 'ad_show_home_page_middle_banner',
      click: 'ad_click_home_page_middle_banner',
    },
    data
  )
  return (
    <section
      ref={ref}
      onClick={() => {
        handleClick()
        window.open(data.web_url, '_blank')
      }}
    >
      <img src={applyHttpsImage(data.image.url)} />
      <Label text={data.label} />
      <style jsx>
        {`
          section {
            position: relative;
            height: 90px;
            overflow: hidden;
            margin-top: 20px;
            width: 1196px;
          }
          img {
            width: 100%;
            border-radius: 2px;
            vertical-align: middle;
          }
        `}
      </style>
    </section>
  )
}

export default TonglanAD2
